<div class="container">
  <div class="example-card">
    <h1>Example Card Credit</h1>
    <d-credit-card #creditCardComponent></d-credit-card>
    <form [formGroup]="form">

      <label for="creditcard_number">Número de tarjeta</label>
      <input type="text" id="creditcard_number" formControlName="cardNumber" #creditCardNumberRef> <br>

      <label for="creditcard_person_name">Nombre</label>
      <input type="text" id="creditcard_person_name" formControlName="cardPersonName" #creditCardPersonNameRef> <br>

      <label for="creditcard_date_valid">Fecha de Vencimiento</label>
      <input type="text" id="creditcard_date_valid" formControlName="validDate" #creditCardDateValidRef> <br>

      <label for="creditcard_date_valid">CVC</label>
      <input type="text" id="creditcard_cvc" formControlName="cvc" #creditCardCVC>
    </form>
  </div>

  <div class="example-custom-card">
    <h1>Custom Card</h1>
    <form [formGroup]="formCustomCard">

      <d-credit-card [labelInitialCardNumber]="labelInitialCardNumber?.value" #customCreditCardComponentRef
        [labelInitialDateValid]="labelInitialDateValid?.value" [labelInitialPersonName]="labelInitialPersonName?.value"
        [labelMonthYear]="labelTextLabelMonthYear?.value" [labelValidUntilText]="labelValidUntilText?.value"
        [labelInitialCVC]="labelInitialCVC?.value" [labelTextFooter]="labelTextFooter?.value">

        <label for="creditcard_number">Número de tarjeta</label>
        <input type="text" id="creditcard_number" formControlName="cardNumber" #inputNumberRef> <br>

        <label for="creditcard_person_name">Nombre</label>
        <input type="text" id="creditcard_person_name" formControlName="cardPersonName" #inputNameRef> <br>

        <label for="creditcard_date_valid">Fecha de Vencimiento</label>
        <input type="text" id="creditcard_date_valid" formControlName="validDate" #inputValidDateRef> <br>

        <label for="creditcard_date_valid">CVC</label>
        <input type="text" id="creditcard_date_valid" formControlName="cvc" #inputCVCRef>

      </d-credit-card>

      <h3>Options to module with forRoot()</h3>

      <label for="creditcard_number">Placeholder card number</label>
      <input formControlName="labelInitialCardNumber" type="text"> <br>

      <label for="creditcard_number">Placeholder Date Valid</label>
      <input formControlName="labelInitialDateValid" type="text"> <br>

      <label for="creditcard_number">Placeholder PersonName</label>
      <input formControlName="labelInitialPersonName" type="text"> <br>

      <label for="creditcard_number">Text Label Month Year</label>
      <input formControlName="labelTextLabelMonthYear" type="text"> <br>

      <label for="creditcard_number">Placeholder Valid Until</label>
      <input formControlName="labelValidUntilText" type="text"> <br>

      <label for="creditcard_number">Placeholder Label Initial CVC</label>
      <input formControlName="labelInitialCVC" type="text"> <br>

      <label for="creditcard_number">Placeholder LabelTextFooter</label>
      <input formControlName="labelTextFooter" type="text"> <br>

    </form>

    <h5>Example Code forRoot()</h5>
    <pre>
      <code>
        CreditCardModule.forRoot(&#x7b;
         cardFront: &#x7b;
          labelInitialCardNumber: '{{ labelInitialCardNumber?.value }}',
          labelInitialDateValid: '{{ labelInitialDateValid?.value }}',
          labelInitialPersonName: '{{ labelInitialPersonName?.value }}',
          labelTextLabelMonthYear: '{{ labelTextLabelMonthYear?.value }}',
          labelValidUntilText: '{{ labelValidUntilText?.value }}'
         &#x7d;,
         cardBack: &#x7b;
          labelInitialCVC: '{{ labelInitialCVC?.value }}',
          labelTextFooter: '{{ labelTextFooter?.value }}'
         &#x7d;
        &#x7d;)
      </code>
    </pre>
  </div>
  <!-- <lib-layout3d></lib-layout3d> -->